
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTable } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, tap } from 'rxjs/operators';
import { makeArray } from 'src/app/shared/functions/objToArray';
import { SnackBarItem } from 'src/app/shared/global_components/snack-bar/snack-bar-item';
import { BaseClass } from 'src/app/shared/models/base-class';
import { LanguageService } from 'src/app/shared/services/common/language.service';
import { LayoutService } from 'src/app/shared/services/common/layout.service';
import { StorageManagerService } from 'src/app/shared/services/common/storage-manager.service';
import { AuthService } from 'src/app/shared/services/rest/auth.service';
import { CompanyService } from 'src/app/shared/services/rest/company.service';
import { TaskService } from 'src/app/shared/services/rest/task.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-stat-by-month',
  templateUrl: './stat-by-month.component.html',
  styleUrls: ['./stat-by-month.component.scss']
})
export class StatByMonthComponent extends BaseClass implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("pointContainer") pointContainer: ElementRef;
  @ViewChild("currencyContainer") currencyContainer: ElementRef;
  @ViewChildren(MatTable) table: MatTable<any>;
  public host: any = environment.host;
  public imgRoute: any = '';
  public user: any = {};
  public user_id: number;
  public company_id: any;
  public activeLang: any;
  public company: any;
  public pagination: object = {};
  public page: number = 1;
  public stats: any[] = [];
  public displayedColumns: string[] = ['Month', 'Pending', 'Ready', 'Total'];
  public selectedIndex: number = 0;
  // public mockData = [{"id":22,"company_id":19,"employee_id":32,"time_start":1635724800,"time_end":1638316799,"summary_rate":"0.0000","summary_price":"800.0000","to_approve_summary_rate":"0.0000","to_approve_summary_price":"0.0000","approved_summary_rate":"0.0000","approved_summary_price":"800.0000","currency_id":2,"created_at":1635967741,"updated_at":1635996542,"employee":{"id":32,"company_id":19,"user_id":11,"created_at":1627410569,"rate_target":"0.0000","salary":"0.0000","currency_id":2,"permissions":null},"currency":{"id":2,"rate":"0.0000","name":"Российский рубль","short_name":"₽","iso_name":"RUB","display_format":"₽ {value}","created_at":0,"updated_at":0}},{"id":14,"company_id":19,"employee_id":32,"time_start":1633046400,"time_end":1635724799,"summary_rate":"0.0000","summary_price":"8600.0000","to_approve_summary_rate":"0.0000","to_approve_summary_price":"250.0000","approved_summary_rate":"0.0000","approved_summary_price":"8350.0000","currency_id":2,"created_at":1634221741,"updated_at":1635726541,"employee":{"id":32,"company_id":19,"user_id":11,"created_at":1627410569,"rate_target":"0.0000","salary":"0.0000","currency_id":2,"permissions":null},"currency":{"id":2,"rate":"0.0000","name":"Российский рубль","short_name":"₽","iso_name":"RUB","display_format":"₽ {value}","created_at":0,"updated_at":0}},{"id":10,"company_id":19,"employee_id":32,"time_start":1630454400,"time_end":1633046399,"summary_rate":"91.0000","summary_price":"0.0000","to_approve_summary_rate":"67.0000","to_approve_summary_price":"0.0000","approved_summary_rate":"24.0000","approved_summary_price":"0.0000","currency_id":0,"created_at":1630942141,"updated_at":1632994141,"employee":{"id":32,"company_id":19,"user_id":11,"created_at":1627410569,"rate_target":"0.0000","salary":"0.0000","currency_id":2,"permissions":null},"currency":null},{"id":10,"company_id":19,"employee_id":32,"time_start":1630454400,"time_end":1633046399,"summary_rate":"0.0000","summary_price":"3350.0000","to_approve_summary_rate":"0.0000","to_approve_summary_price":"3350.0000","approved_summary_rate":"0.0000","approved_summary_price":"0.0000","currency_id":0,"created_at":1630942141,"updated_at":1632994141,"employee":{"id":32,"company_id":19,"user_id":11,"created_at":1627410569,"rate_target":"0.0000","salary":"0.0000","currency_id":2,"permissions":null},"currency":null},{"id":11,"company_id":19,"employee_id":32,"time_start":1630454400,"time_end":1633046399,"summary_rate":"0.0000","summary_price":"12620.0000","to_approve_summary_rate":"0.0000","to_approve_summary_price":"9820.0000","approved_summary_rate":"0.0000","approved_summary_price":"2800.0000","currency_id":2,"created_at":1630942141,"updated_at":1632994141,"employee":{"id":32,"company_id":19,"user_id":11,"created_at":1627410569,"rate_target":"0.0000","salary":"0.0000","currency_id":2,"permissions":null},"currency":{"id":2,"rate":"0.0000","name":"Российский рубль","short_name":"₽","iso_name":"RUB","display_format":"₽ {value}","created_at":0,"updated_at":0}},{"id":6,"company_id":19,"employee_id":32,"time_start":1627776000,"time_end":1630454399,"summary_rate":"0.0000","summary_price":"18100.0000","to_approve_summary_rate":"0.0000","to_approve_summary_price":"6550.0000","approved_summary_rate":"0.0000","approved_summary_price":"11550.0000","currency_id":2,"created_at":1630942141,"updated_at":1630942141,"employee":{"id":32,"company_id":19,"user_id":11,"created_at":1627410569,"rate_target":"0.0000","salary":"0.0000","currency_id":2,"permissions":null},"currency":{"id":2,"rate":"0.0000","name":"Российский рубль","short_name":"₽","iso_name":"RUB","display_format":"₽ {value}","created_at":0,"updated_at":0}},{"id":3,"company_id":19,"employee_id":32,"time_start":1625097600,"time_end":1627775999,"summary_rate":"0.0000","summary_price":"7150.0000","to_approve_summary_rate":"0.0000","to_approve_summary_price":"0.0000","approved_summary_rate":"0.0000","approved_summary_price":"7150.0000","currency_id":2,"created_at":1630942141,"updated_at":1630942141,"employee":{"id":32,"company_id":19,"user_id":11,"created_at":1627410569,"rate_target":"0.0000","salary":"0.0000","currency_id":2,"permissions":null},"currency":{"id":2,"rate":"0.0000","name":"Российский рубль","short_name":"₽","iso_name":"RUB","display_format":"₽ {value}","created_at":0,"updated_at":0}}] 
  constructor(
    private sm: StorageManagerService,
    private auth: AuthService,
    private companyService: CompanyService,
    private fb: FormBuilder,
    private languageService: LanguageService,
    private activatedRoute: ActivatedRoute,
    private taskService: TaskService,
    private router: Router,
    private layoutService: LayoutService
  ) { super() }

  ngOnInit(): void {
    window.scroll(0,0);

    this.company_id = this.activatedRoute.snapshot.queryParamMap.get('company_id');

    this.getLangData();
    this.getCompany();
    this.getImgRoute();
    this.getCsrf();
    this.getUser();

    this.getAllRateStats(this.page);

  }

  getLangData() {
    this.attachSubscriptions(
      this.languageService.getLangData().subscribe(resp => {
        this.activeLang = resp.active;
      })
    )
  }

  getCompany() {
    this.attachSubscriptions(
      this.companyService.getCompany(this.company_id).subscribe(resp => {
        this.companyService.company$.next(resp[0]);
        this.company = resp[0];
        console.log(resp);
        if (!!resp[0] && !!resp[0].employees && !!resp[0].employees[0]) {
          this.company['rate_target'] = resp[0].employees[0].rate_target
        }
      })
    )
  }

  refreshStats() {
    this.attachSubscriptions(
      this.taskService.refreshStats(this.company_id).subscribe(resp => {
        // console.log(resp);
        this.page = 1;
        this.stats = [];
        this.getAllRateStats(this.page);
        this.table['_results'].forEach(element => {
          element.renderRows();
        });
        this.layoutService.showSnackBar({name: ''}, marker("Stats is updated"), SnackBarItem)
      })
    )
  }

  getImgRoute() {
    this.attachSubscriptions(
      this.sm.getImgPath().subscribe(el => {
        this.imgRoute = el;
      })
    )
  }

  getCsrf() {
    this.attachSubscriptions(
      this.auth.$userToken.subscribe(resp => {
        this.user_id = resp.user_id;
        this.sm.localStorageSetItem("csrf_param", resp.csrf_param)
        this.sm.localStorageSetItem("csrf_token", resp.csrf_token)
      })
    )
  }

  getUser() {
    this.attachSubscriptions(
      this.auth.$user.subscribe(resp => {
        this.user = resp;
      })
    )
  }

  ngAfterViewInit(): void {
    this.pointContainer.nativeElement.scrollTop = 0;
    this.currencyContainer.nativeElement.scrollTop = 0;
    this.onScroll();
  }

  onScroll() {
    this.attachSubscriptions(
      fromEvent([this.pointContainer.nativeElement, this.currencyContainer.nativeElement], "scroll").pipe(
        filter((e:any) => e.target.scrollTop >=  e.target.scrollHeight - e.target.offsetHeight - 400),
        debounceTime(300),
        map((e:any) => Math.ceil((e.target.scrollTop + e.target.innerHeight)/ (400))),
        distinctUntilChanged()
      ).subscribe(() => {
          if (this.page <= this.pagination['pageCount']) {
            this.getAllRateStats(this.page);
          }
        }
      )
    )
  }

  goToStats(e, start, end, status) {
    e.preventDefault();
    console.log(start, end, status);
    this.router.navigate(['/tasks'], { queryParams: {
      company_id: this.company_id,
      operation_completed_at_from: +start + 1,
      operation_completed_at_to: +end,
      operation_status_id: status.join(",")
    }});
  }

  getAllRateStats(page) {
    this.attachSubscriptions(
      this.taskService.getAllRateStats(this.company_id, page).pipe(
        tap(el => {
          this.pagination = {
            'pageCount': el.headers.get('x-pagination-page-count'),
            'perPage': el.headers.get('x-pagination-per-page'),
            'totalCount': el.headers.get('x-pagination-total-count'),
            'currentPage': el.headers.get('x-pagination-current-page'),
          }
        }),
        map(el => el.body),
      ).subscribe(resp => {
        let mounths = [];

        resp.forEach(element => {
          if (!mounths.find(x => x.time_start == element.time_start)) {
            mounths.push({
              time_start: element.time_start,
              time_end: element.time_end
            });
          }
        });

        mounths.forEach(element => {
          this.stats.push({
            rate: resp.filter(x => x.time_start == element.time_start).find(x => x.currency_id == 0) ? resp.filter(x => x.time_start == element.time_start).find(x => x.currency_id == 0) : false,
            salary: resp.filter(x => x.time_start == element.time_start),
            time_start: element.time_start,
            time_end: element.time_end
          })
        });


        console.log("this.stats",  this.stats);
        this.table['_results'].forEach(element => {
          element.renderRows();
        });

        this.page = this.page + 1;
      })
    )
  }

  selectTab(e) {
    this.selectedIndex = e;
  }

  goBack() {
    history.back();
  }

  ngOnDestroy(): void {
    this.clearSubscriptions()
  }
}